import { useEffect, useState } from 'react';
import { Box, Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, Select, TextField, Icon } from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import AptaTable from 'examples/AptaTable';
import { SERVER_URL } from 'constants/constant';
import Swal from 'sweetalert2';

const Groups = () => {
    const [groups, setGroups] = useState([]);
    const [judges, setJudges] = useState([]);
    const [open, setOpen] = useState(false);
    const [roleType, setRoleType] = useState('add');
    const [groupDetails, setGroupDetails] = useState({ groupName: "" });

    useEffect(() => {
        fetchGroups();
        fetchJudges();
    }, []);

    const fetchGroups = async () => {
        const response = await fetch(`${SERVER_URL}/get-all-groups`);
        const data = await response.json();
        setGroups(data || []);
    };

    const fetchJudges = async () => {
        const response = await fetch(`${SERVER_URL}/get-all-judges`);
        const data = await response.json();
        setJudges(data?.judges || []);
    };

    const handleSaveGroup = async (data) => {
        try {
            const method = roleType === 'add' ? 'POST' : 'PUT';
            const url = roleType === 'add' ? `${SERVER_URL}/create-group` : `${SERVER_URL}/edit-group/${data._id}`;

            const response = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ groupName: data.groupName })
            });

            if (response.ok) {
                Swal.fire({ icon: 'success', text: roleType === 'add' ? "Group created successfully!" : "Group updated successfully!" });
                fetchGroups();
            } else {
                Swal.fire({ icon: 'error', text: "Operation failed. Try again!" });
            }
        } catch (error) {
            Swal.fire({ icon: 'error', text: "An error occurred!" });
        } finally {
            setOpen(false);
        }
    };

    const handleDeleteGroup = async (groupId) => {
        await fetch(`${SERVER_URL}/delete-group/${groupId}`, { method: 'DELETE' });
        fetchGroups();
    };

    const handleAssignJudge = async (groupId, judgeId) => {
        await fetch(`${SERVER_URL}/add-judge/${groupId}/judges/${judgeId}`, { method: 'POST' });
        Swal.fire("Successfully assigned!")
        fetchGroups();
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box display={'flex'} mb={3} justifyContent={'end'}>
                <Button startIcon={<Icon>add</Icon>} variant='contained' color='primary'
                    style={{ color: 'white' }} onClick={() => { setRoleType('add'); setGroupDetails({ groupName: "" }); setOpen(true); }}>
                    Add Group
                </Button>
            </Box>
            <AptaTable
                columns={['Group Name', 'Judge1', 'Judge2', 'Actions']}
                rows={groups?.map((group) => {
                    const assignedJudgeIds = groups.flatMap(g => g.judges?.map(j => j._id) || []);
                    const availableJudges = judges.filter(judge => !assignedJudgeIds.includes(judge._id));

                    const judge1 = group.judges?.[0] ? group.judges[0]._id : "";
                    const judge2 = group.judges?.[1] ? group.judges[1]._id : "";

                    return {
                        'Group Name': group.groupName,
                        'Judge1': (
                            <FormControl fullWidth>
                                {judge1 ? group.judges?.[0]?.name : (
                                    <Select
                                        value={judge1}
                                        onChange={(e) => handleAssignJudge(group._id, e.target.value)}
                                        disabled={judge1}
                                        displayEmpty
                                        style={{ padding: 10, margin: 10 }}
                                    >
                                        <MenuItem value="" disabled>Select any Judge</MenuItem>
                                        {availableJudges.map(judge => (
                                            <MenuItem key={judge._id} value={judge._id}>{judge.name}</MenuItem>
                                        ))}
                                    </Select>
                                )}
                            </FormControl>
                        ),
                        'Judge2': (
                            <FormControl fullWidth>
                                {judge2 ? group.judges?.[1]?.name : (
                                    <Select
                                        value={judge2}
                                        onChange={(e) => handleAssignJudge(group._id, e.target.value)}
                                        displayEmpty
                                        disabled={judge2}
                                        style={{ padding: 10, margin: 10 }}
                                    >
                                        <MenuItem value="" disabled>Select any Judge</MenuItem>
                                        {availableJudges.map(judge => (
                                            <MenuItem key={judge._id} value={judge._id}>{judge.name}</MenuItem>
                                        ))}
                                    </Select>
                                )}
                            </FormControl>
                        ),
                        'Actions': (
                            <ButtonGroup size='small'>
                                <Button color='info' onClick={() => { setRoleType('edit'); setGroupDetails(group); setOpen(true); }}>
                                    <Icon color='info' >edit</Icon>
                                </Button>
                            </ButtonGroup>
                        )
                    };
                })}
            />

            <InputFormModal open={open} onClose={() => setOpen(false)} onSave={handleSaveGroup} details={groupDetails} type={roleType} />
        </DashboardLayout>
    );
};

export default Groups;
const InputFormModal = ({ open, onClose, onSave, details, type }) => {
    const [formData, setFormData] = useState(details);

    useEffect(() => {
        setFormData(details);
    }, [details]);

    const handleChange = (e) => {
        console.log(e.target.value);

        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{type === 'add' ? 'Add Group' : 'Edit Group'}</DialogTitle>
            <DialogContent>
                <TextField label="Group Name" name="groupName" value={formData.groupName} onChange={handleChange} fullWidth margin="normal" />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={() => onSave(formData)} variant="contained" color="primary" style={{ color: 'white' }}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};
